import React from 'react'

class NavAusbildungsplan extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M3.846 1.5c-.993 0-1.295.058-1.604.223a1.227 1.227 0 0 0-.519.52c-.165.308-.223.61-.223 1.603v12.308c0 .993.058 1.295.223 1.604.122.227.292.397.52.519.308.165.61.223 1.603.223h12.308c.993 0 1.295-.058 1.604-.223.227-.122.397-.292.519-.52.165-.308.223-.61.223-1.603V3.846c0-.993-.058-1.295-.223-1.604a1.227 1.227 0 0 0-.52-.519c-.308-.165-.61-.223-1.603-.223H3.846zm0-1.5h12.308c1.337 0 1.822.14 2.311.4.49.262.873.646 1.134 1.135.262.489.401.974.401 2.31v12.31c0 1.336-.14 1.821-.4 2.31a2.726 2.726 0 0 1-1.135 1.134c-.489.262-.974.401-2.31.401H3.844c-1.336 0-1.821-.14-2.31-.4A2.726 2.726 0 0 1 .4 18.464C.139 17.976 0 17.491 0 16.155V3.844c0-1.336.14-1.821.4-2.31A2.726 2.726 0 0 1 1.536.4C2.024.139 2.509 0 3.845 0zM6 16a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5-9h5v1h-5V6zm0 7h5v1h-5v-1zM5.335 6.774L7.8 4.157l.728.686-3.186 3.383-1.803-1.88.722-.692 1.074 1.12z"
        />
      </svg>
    )
  }
}

export default NavAusbildungsplan
